import React, {Component} from 'react';
import {Grid, Row, Col} from "react-bootstrap";
import TopBreadcumb from "../../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../../shared/sidebar/SidebarComponent";
import Links from "../../../../utilities/linksConfig/Links";
import ReactNotify from 'react-notify';
import FakturyBiletySearchbox from "./components/FakturyBiletySearchbox";
import moment from "moment";
import DataAndTimeFormat from "../../../../utilities/DateAndTimeFormat";
import FakturyBiletyService from "./FakturyBiletyService";
import FakturyBiletyTable from "./components/FakturyBiletyTable";


export default class FakturyBiletyContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            params: null,
            faktury:[]
        };
        this.onClickSzukaj = this.onClickSzukaj.bind(this)
    }

    componentDidMount() {
       /* let now = moment();
        let obecny_rok = (now.year());
        let obecny_miesiac = (now.month()) + 1;

        let pierwszy_miesiaca = moment(obecny_rok + '-' + obecny_miesiac + '-01')

        let ostatni_miesiaca = moment(obecny_rok + '-' + obecny_miesiac + '-' + moment(now).daysInMonth())*/

        this.onClickSzukaj({
            dataOd: DataAndTimeFormat.formatYYYYMMDD(moment()),
            dataDo: DataAndTimeFormat.formatYYYYMMDD(moment()),
            nipLubPesel:''
        })
    }

    onClickSzukaj(params) {
        this.setState({params: params})

        FakturyBiletyService.getFakturyBilety(params).then(function (response) {
            this.setState({faktury:response.data})
        }.bind(this))
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'ZarzadzanieBiletamiContainer'}>
                    <ReactNotify ref='notificator'/>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{addressUrl: '/konfiguracja', text: 'Konfiguracja'}, {
                                    addressUrl: '/konfiguracja/zarzadzanie-biletami',
                                    text: 'Zarządzanie biletami'
                                }, {addressUrl: '/konfiguracja/zarzadzanie-biletami/faktury', text: 'Faktury'}]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col xs={12}>
                            <FakturyBiletySearchbox handleClickSearch={this.onClickSzukaj}/>
                        </Col>
                        <Col xs={12}>
                            <FakturyBiletyTable data={this.state.faktury}/>
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/fakturyBilety/FakturyBiletyContainer.js